import { TrashIcon } from "@primer/octicons-react";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { PEG_BOARD_ADD, PEG_BOARD_EDIT, PEG_BOARD_UPDATE } from "../../../../../../constants/pegBoardTypes";

class PegBoardSettingCard extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            gapW: this.props.peg.gapW,
            gapH: this.props.peg.gapH,
            pegLength: this.props.peg.pegLength,
            isSaveEnabled: true
        }
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            prevState => ({
            ...prevState,
            [name]: value
            }),
            this.toggleSaveButton
        );
    };

    toggleSaveButton = () => {
        const { gapW, gapH, pegLength } = this.state;
        // Enable Save button if all inputs are non-empty
        const isSaveEnabled = gapW !== '' && gapW > 0 && gapH !== '' && gapH > 0 && pegLength !== '' && pegLength > 0;

        this.setState({ isSaveEnabled });
      };



    render() {
        return (
            <React.Fragment key={this.props.key}>
                <div className="peg-board-setting-card">
                    <div className="peg-board-setting-header">
                        <div className="peg-board-name-label">{this.props.t("PEG_BOARD")} {this.props.peg.name}</div>
                        <span className="peg-board-width-height-label">W {this.props.peg.pegDrawingRect?.pegRectEndxLabelVal?Math.floor(this.props.peg.pegDrawingRect?.pegRectEndxLabelVal * 100) / 100 :0} H {this.props.peg.pegDrawingRect?.heightLabelVal?Math.floor(this.props.peg.pegDrawingRect?.heightLabelVal * 100) / 100:0} ({this.props.t('uomlist.meters')})</span>
                    </div>
                    <div className="peg-board-setting-body">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <span className="custom-label">{this.props.t("GAP")} W ({this.props.t("uomlist.CM_SHORT")})</span>
                                    <Form.Control name="gapW" type="number" placeholder="" className="peg-board-setting-input" value={this.state.gapW} onChange={this.handleInputChange} /*onChange={(e) => this.setState({ gapW: e.target.value })}*/ disabled={this.props.peg?.pegBoardStatus === PEG_BOARD_EDIT || !this.props.peg?.pegBoardStatus && true}/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <span className="custom-label">{this.props.t("GAP")} H ({this.props.t("uomlist.CM_SHORT")})</span>
                                    <Form.Control name="gapH" type="number" placeholder="" className="peg-board-setting-input" value={this.state.gapH} onChange={this.handleInputChange} /*onChange={(e) => this.setState({ gapH: e.target.value })}*/ disabled={this.props.peg?.pegBoardStatus === PEG_BOARD_EDIT || !this.props.peg?.pegBoardStatus && true}/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    {/* <Form.Label >{this.props.t("PEG_LENGTH")} ({this.props.t("uomlist.CM_SHORT")})</Form.Label> */}
                                    <span className="custom-label">{this.props.t("PEG_LENGTH")} ({this.props.t("uomlist.CM_SHORT")})</span>
                                    <Form.Control name="pegLength" type="number" placeholder="" className="peg-board-setting-input" value={this.state.pegLength} onChange={this.handleInputChange} /*onChange={(e) => this.setState({ pegLength: e.target.value })}*/ disabled={this.props.peg?.pegBoardStatus === PEG_BOARD_EDIT || !this.props.peg?.pegBoardStatus && true}/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="peg-board-setting-footer">
                        <hr className="peg-board-setting-custom-divider" />
                        <Row>
                            <Col>
                                <Button onClick={() => this.props.handleDeletePeg(this.props.peg?.pegBoardIndex)} size="sm" className={(this.props.isRTL === "rtl" ? "peg-board-setting-delete-btn-rtl" : "peg-board-setting-delete-btn-ltr")}><TrashIcon size={12}/></Button>
                            </Col>
                            <Col>
                                {this.props.peg?.pegBoardStatus === PEG_BOARD_ADD && 
                                    <Button disabled={!this.state.isSaveEnabled || !this.props.isRectDrawingCompleted} variant='success' onClick={() => this.props.handleAddPegHoles(this.props.peg?.pegBoardIndex, this.state)} size="sm" className={this.props.isRTL === "rtl" ? "peg-board-setting-save-btn-rtl" : "peg-board-setting-save-btn-ltr"}>{this.props.t('btnnames.save')}</Button>
                                }
                                {this.props.peg?.pegBoardStatus === PEG_BOARD_EDIT && 
                                    <Button variant='primary' onClick={() => this.props.handleEditPegHoles(this.props.peg?.pegBoardIndex, this.state)} size="sm" className={this.props.isRTL === "rtl" ? "peg-board-setting-update-btn-rtl" : "peg-board-setting-update-btn-ltr"}>{this.props.t('btnnames.edit')}</Button>
                                }
                                {this.props.peg?.pegBoardStatus === PEG_BOARD_UPDATE &&
                                    <Button disabled={!this.state.isSaveEnabled} variant='success' onClick={() => this.props.handleUpdatePegHoles(this.props.peg?.pegBoardIndex, this.state)} size="sm" className={this.props.isRTL === "rtl" ? "peg-board-setting-save-btn-rtl" : "peg-board-setting-save-btn-ltr"}>{this.props.t('btnnames.update')}</Button>
                                }
                                {/* temporary add - waiting for backend */}
                                {!this.props.peg?.pegBoardStatus && 
                                    <Button variant='primary' onClick={() => this.props.handleEditPegHoles(this.props.peg?.pegBoardIndex, this.state)} size="sm" className={this.props.isRTL === "rtl" ? "peg-board-setting-update-btn-rtl" : "peg-board-setting-update-btn-ltr"}>{this.props.t('btnnames.edit')}</Button>
                                }
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default withTranslation()(withRouter(connect(null)(PegBoardSettingCard)));